import React from 'react';
import { useNavigate } from 'react-router-dom';
import Layout from 'layouts/member/Layout';

// アイコン画像のimport
import iconWater from 'assets/themes/default/menu_water.png';
import iconLight from 'assets/themes/default/menu_light.png';
import iconAircon from 'assets/themes/default/menu_aircon.png';
import iconPest from 'assets/themes/default/menu_pest.png';
import iconKitchen from 'assets/themes/default/menu_kitchen.png';
import iconPC from 'assets/themes/default/menu_pc.png';
import iconKeydoor from 'assets/themes/default/menu_keydoor.png';
import iconWindow from 'assets/themes/default/menu_window.png';
import iconHuman from 'assets/themes/default/menu_human.png';
import iconSubscription from 'assets/themes/default/menu_subscription.png';
import iconNews from 'assets/themes/default/menu_news.png';
import iconAccount from 'assets/themes/default/menu_account.png';

interface MenuItem {
  title: string;
  icon: string;
}

const menuItems: MenuItem[] = [
  { title: "水回り", icon: iconWater },
  { title: "電気", icon: iconLight },
  { title: "空調", icon: iconAircon },
  { title: "害虫", icon: iconPest },
  { title: "厨房機器", icon: iconKitchen },
  { title: "PC／ネット", icon: iconPC },
  { title: "カギ扉", icon: iconKeydoor },
  { title: "内装ガラス", icon: iconWindow },
  { title: "人材", icon: iconHuman },
  { title: "定額レスキュー", icon: iconSubscription },
  { title: "NEWS", icon: iconNews },
  { title: "会員情報", icon: iconAccount },
];

const Home: React.FC = () => {
  const navigate = useNavigate();

  return (
    <Layout>
      <div className="flex flex-col">
        <section className="flex flex-col justify-center flex-1">
          <div className="flex flex-col justify-center w-full max-w-3xl px-2 py-10 mx-auto sm:px-4">
            <h2 className="mb-10 text-base font-bold tracking-wide text-center text-gray-800">
              緊急項目を選択してください
            </h2>
            <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 md:grid-cols-3">
              {menuItems.map(({ title, icon }, idx) => (
                <button
                  key={title}
                  onClick={() => navigate(`/service/${idx}`)}
                  className="flex flex-col items-center justify-center min-w-0 p-4 transition-all duration-200 bg-white border border-transparent shadow-xl sm:p-6 rounded-2xl hover:shadow-2xl hover:-translate-y-2 group hover:border-blue-400 focus:outline-none focus:ring-2 focus:ring-blue-300"
                  style={{ maxWidth: '100%' }}
                >
                  <div className="flex items-center justify-center mb-3 rounded-full shadow-inner w-14 h-14 sm:w-16 sm:h-16 bg-gradient-to-br from-blue-50 to-blue-100 group-hover:from-blue-100 group-hover:to-blue-200">
                    <img src={icon} alt={title} className="object-contain w-8 h-8 sm:w-10 sm:h-10" />
                  </div>
                  <span className="text-sm font-semibold text-center text-gray-700 break-words transition sm:text-base group-hover:text-blue-700">
                    {title}
                  </span>
                </button>
              ))}
            </div>
            <div className="flex justify-center mt-10 space-x-6">
              <button className="px-5 py-2 font-semibold text-blue-700 transition bg-white border border-blue-300 rounded-full shadow hover:bg-blue-50 hover:text-blue-900">
                FAQ
              </button>
              <button className="px-5 py-2 font-semibold text-blue-700 transition bg-white border border-blue-300 rounded-full shadow hover:bg-blue-50 hover:text-blue-900">
                会社概要
              </button>
            </div>
          </div>
        </section>
      </div>
    </Layout>
  );
};

export default Home;